import { format } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'

export function formatTimestampToWeekdayMonthDayString(
  timestamp: number,
  timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
): string {
  const date = new Date(timestamp * 1000)
  const zonedDate = toZonedTime(date, timeZone)

  return format(zonedDate, 'EEE MMM dd')
}

export function formatTimestampToTimeString(
  timestamp: number,
  timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
): string {
  const date = new Date(timestamp * 1000)
  const zonedDate = toZonedTime(date, timeZone)

  return format(zonedDate, 'HH:mm')
}

export function formatTimestampToTimezoneString(
  timestamp: number,
  timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone
): string {
  const date = new Date(timestamp * 1000)
  const zonedDate = toZonedTime(date, timeZone)

  return format(zonedDate, 'zzz')
}

export function now(): number {
  return Math.floor((new Date()).getTime() / 1000)
}
